import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom';
import Blog_01 from '../../../assets/images/svg/arrow-link.svg';
import Blog_02 from '../../../assets/images/blog/blog-author-1.png';
import Blog_03 from '../../../assets/images/blog/blog-author-2.png';
import Blog_04 from '../../../assets/images/blog/blog-1.jpg';
import Blog_05 from '../../../assets/images/blog/blog-2.jpg';
import Blog_06 from '../../../assets/images/blog/blog-3.jpg';

const Blog = () => {
    const blogslider = {
        Infinity: true,
        dots: false,
        autoplay: true,
        slidesToShow: 3,
        speed: 500,
        button: false,
        arrows: false,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    Infinity: true
                },
                breakpoint: 740,
                setting: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    Infinity: true
                },
                breakpoints: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    Infinity: true
                },
            }
        ]
    };

    return (
        <>
            <div className="blog-section-one">
                <div className="container-fluid p-0">
                    <Slider className="blog-one-slider" {...blogslider}>
                        <div className="blog-box-one">
                            <div className="blog-image-one">
                                <img src={Blog_04} alt="blog-image" />
                                <Link to="/BlogDetails" className="btn-link">
                                    <img src={Blog_01} alt="icon" />
                                </Link>
                            </div>
                            <div className="blog-details-one">
                                <div className="blog-meta-one">
                                    <Link to="/BlogDetails" className="blog-date-one">
                                        18 November 2024{" "}
                                    </Link>
                                    <Link to="/BlogDetails" className="blog-tag-one">
                                        Marketing
                                    </Link>
                                </div>
                                <h4 className="blog-title-one">
                                    <Link to="/BlogDetails">
                                        Business development strategies with Saga
                                    </Link>
                                </h4>
                                <div className="blog-author-one">
                                    <img src={Blog_02} alt="" />
                                    <Link to="/BlogDetails">
                                        <span>by </span> Mitta blrow
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="blog-box-one">
                            <div className="blog-image-one">
                                <img src={Blog_05} alt="blog-image" />
                                <Link to="/BlogDetails" className="btn-link">
                                    <img src={Blog_01} alt="icon" />
                                </Link>
                            </div>
                            <div className="blog-details-one">
                                <div className="blog-meta-one">
                                    <Link to="/BlogDetails" className="blog-date-one">
                                        18 November 2024{" "}
                                    </Link>
                                    <Link to="/BlogDetails" className="blog-tag-one">
                                        work
                                    </Link>
                                </div>
                                <h4 className="blog-title-one">
                                    <Link to="/BlogDetails">
                                        A Business Consulting That Can Produce Anything.
                                    </Link>
                                </h4>
                                <div className="blog-author-one">
                                    <img
                                        src={Blog_02}
                                        alt="author-image"
                                    />
                                    <Link to="/BlogDetails">
                                        <span>by </span> Mari Smith
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="blog-box-one">
                            <div className="blog-image-one">
                                <img src={Blog_06} alt="blog-image" />
                                <Link to="/BlogDetails" className="btn-link">
                                    <img src={Blog_01} alt="icon" />
                                </Link>
                            </div>
                            <div className="blog-details-one">
                                <div className="blog-meta-one">
                                    <Link to="/BlogDetails" className="blog-date-one">
                                        18 November 2024{" "}
                                    </Link>
                                    <Link to="/BlogDetails" className="blog-tag-one">
                                        Analysis
                                    </Link>
                                </div>
                                <h4 className="blog-title-one">
                                    <Link to="/BlogDetails">
                                        New Consulting For All Kind Offer Business Finance
                                    </Link>
                                </h4>
                                <div className="blog-author-one">
                                    <img
                                        src={Blog_03}
                                        alt="author-image"
                                    />
                                    <Link to="/BlogDetails">
                                        <span>by </span>Peeter Park
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="blog-box-one">
                            <div className="blog-image-one">
                                <img src={Blog_04} alt="blog-image" />
                                <Link to="/BlogDetails" className="btn-link">
                                    <img src={Blog_01} alt="icon" />
                                </Link>
                            </div>
                            <div className="blog-details-one">
                                <div className="blog-meta-one">
                                    <Link to="/BlogDetails" className="blog-date-one">
                                        18 November 2024{" "}
                                    </Link>
                                    <Link to="/BlogDetails" className="blog-tag-one">
                                        Marketing
                                    </Link>
                                </div>
                                <h4 className="blog-title-one">
                                    <Link to="/BlogDetails">
                                        Business development strategies with Saga
                                    </Link>
                                </h4>
                                <div className="blog-author-one">
                                    <img
                                        src={Blog_01}
                                        alt="author-image"
                                    />
                                    <Link to="/BlogDetails">
                                        <span>by </span> Shama Hyder
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>

        </>
    )
}

export default Blog
